import { render, staticRenderFns } from "./PSReport.vue?vue&type=template&id=5cf2b512&scoped=true"
import script from "./PSReport.ts?vue&type=script&lang=ts&external"
export * from "./PSReport.ts?vue&type=script&lang=ts&external"
import style0 from "./PSReport.vue?vue&type=style&index=0&id=5cf2b512&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2b512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf2b512')) {
      api.createRecord('5cf2b512', component.options)
    } else {
      api.reload('5cf2b512', component.options)
    }
    module.hot.accept("./PSReport.vue?vue&type=template&id=5cf2b512&scoped=true", function () {
      api.rerender('5cf2b512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/reports/PSReport/PSReport.vue"
export default component.exports